const form = document.getElementById("custom-recharge-form");
const quantityInput = document.getElementById("recharge-quantity");
const quantityElement = document.getElementById("custom-recharge-form-quantity");
const summaryElement = document.getElementById("custom-recharge-form-summary");
const priceElement = document.getElementById("custom-recharge-form-price");
const save_text = document.getElementById("custom-recharge-form-saving");
const start_txt = $.trim($("a.commencer.header__icon.button.button--primary").text());

let config = { childList: true };
let radioContainer = document.getElementById("custom-recharge-form-radios");
let checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');

let quantity;

const linkedProductsSelect = document.getElementById('linked-product-select');

if(quantityInput){
    quantity = parseInt(quantityInput.value);

    let targetNode = document.getElementsByClassName("recharge-subscription-widget")[0].getElementsByTagName("DIV")[0];

    let observer = new MutationObserver(function (mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
                let select = targetNode.querySelector('select[name="rc_selling_plan"]');
                if (select) {
                    let options = select.options;
                    radioContainer.innerHTML = "";
    
                    for (let i = 0; i < options.length; i++) { // Création des radio butons en fonction du select Recharge
                        let option = options[i];
    
                        let divWrapper = document.createElement("div");
                        divWrapper.className = "custom-recharge-form-radio"
    
                        let radio = document.createElement("input");
                        radio.type = "radio";
                        radio.name = "selling_plan";
                        radio.value = option.value;
                        radio.setAttribute("form", productFormId);
                        radio.id = "recharge-frequency-" + i;
                        if (i === options.length - 1)
                            radio.checked = true;
                        
                        let label = document.createElement("label");
                        label.innerHTML = option.text + ((i === options.length - 1)? ' (Standard)' : ' (Extra contrôle des odeurs)');
                        label.setAttribute("for", "recharge-frequency-" + i);
    
    
                        divWrapper.appendChild(radio);
                        divWrapper.appendChild(label);
                        radioContainer.appendChild(divWrapper);
                    }
    
                    observer.disconnect();
                }
            }
        }
    });

    observer.observe(targetNode, config);

} else if(linkedProductsSelect){
    quantity = parseInt(linkedProductsSelect.options[linkedProductsSelect.selectedIndex].dataset.nb);
}

function formatCHF(amt) {
    var n = parseFloat(amt);
    var intPart = Math.floor(n);
    var rappen = Math.round((n - intPart) * 100);
    if (rappen === 0) return 'CHF ' + intPart + '.–';
    return 'CHF ' + intPart + '.' + (rappen < 10 ? '0' + rappen : rappen);
}

// Fonction pour mettre à jour les détails en fonction des inputs
function updateFormDetails() {
    if(quantityInput){
        quantity = parseInt(quantityInput.value);
    } else if(linkedProductsSelect){
        quantity = parseInt(linkedProductsSelect.options[linkedProductsSelect.selectedIndex].dataset.nb);
    }

    const frequencyInputs = document.querySelectorAll('div[class="custom-recharge-form-radio"]');
    let frequency = "";
    frequencyInputs.forEach((input) => {
        radio = input.querySelector('input');
        label = input.querySelector('label');
        if (radio.checked)
            frequency = label.textContent.replace('Livraison', 'livrés');
    });

    var compareTotal = (24 * quantity).toFixed(2);
    var priceTotal   = (22 * quantity).toFixed(2);

    if (quantity > 1) {
        if (save_text) save_text.style.display = "block";
        priceElement.innerHTML = '<span class="compare-price">' + formatCHF(compareTotal) + '</span> ' + formatCHF(priceTotal);
    } else {
        if (save_text) save_text.style.display = "none";
        priceElement.innerHTML = formatCHF(compareTotal);
    }

    var optionText = linkedProductsSelect
        ? linkedProductsSelect.options[linkedProductsSelect.selectedIndex].text
        : "";
    var htmlLang = (document.documentElement.lang || "").toLowerCase();
    var isDE = optionText.indexOf("Katzen") !== -1 || htmlLang.indexOf("de") === 0;

    if (isDE) {
        var freqNum = frequency.indexOf("3") !== -1 ? 3 : 4;
        quantityElement.textContent = quantity + " Pacha-Beutel";
        summaryElement.textContent  = quantity + " Beutel Streu, alle " + freqNum + " Wochen geliefert";
    } else {
        quantityElement.textContent = quantity + " sac" + (quantity > 1 ? "s" : "") + " Pacha";
        summaryElement.textContent  = quantity + " sac" + (quantity > 1 ? "s" : "") + " de litière " + frequency;
    }

}

form.addEventListener("change", updateFormDetails);

// Fonction pour mettre à jour le select Recharge en fonction du radio custom checked
function updateSelectFromRadio() {
    if(targetNode){
      let select = targetNode.querySelector('select[name="rc_selling_plan"]');
    }
    checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');

    if (checkedRadio) {
        select.value = checkedRadio.value;
        let changeEvent = new Event('change', {
            bubbles: true,
            cancelable: true
        });
        // Déclenche l'événement "change" sur le select pour changer l'url avec le selling_plan (comportement normal de Recharge)
        select.dispatchEvent(changeEvent);
    }
}

if(quantityInput){
  radioContainer.addEventListener("change", updateSelectFromRadio);
}

let checkoutButton = document.querySelector('[checkout-button]');

// if(checkoutButton) {
//     checkoutButton.addEventListener('click', goCheckout);
// }
// if (checkoutButton) {
//     checkoutButton.addEventListener('click', function () {
//         alert("Checkout button clicked!");
       
//     });
// }

$(document).on('click', '.pacha-v2-atc', function(e) {
  e.preventDefault();
 
  const nextCommerceData = [
                        {"shopifyId":  "44598917497040", "nextCommerceId": "5", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598917693648", "nextCommerceId": "7", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598917791952", "nextCommerceId": "9", "IntervalCount": "4", "FrequencyTitle": "week"}, 
                        {"shopifyId":  "44598917824720", "nextCommerceId": "11", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598917857488", "nextCommerceId": "13", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598917955792", "nextCommerceId": "15", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598917988560", "nextCommerceId": "17", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918021328", "nextCommerceId": "19", "IntervalCount": "12", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918054096", "nextCommerceId": "21", "IntervalCount": "12", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918054096", "nextCommerceId": "21", "IntervalCount": "12", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918086864", "nextCommerceId": "43", "IntervalCount": "12", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918119632", "nextCommerceId": "35", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918152400", "nextCommerceId": "23", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918185168", "nextCommerceId": "25", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918217936", "nextCommerceId": "37", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918250704", "nextCommerceId": "39", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918283472", "nextCommerceId": "57", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918316240", "nextCommerceId": "49", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918349008", "nextCommerceId": "45", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918381776", "nextCommerceId": "29", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918414544", "nextCommerceId": "51", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918447312", "nextCommerceId": "55", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918480080", "nextCommerceId": "69", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918545616", "nextCommerceId": "31", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44790981624016", "nextCommerceId": "169", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918807760", "nextCommerceId": "139", "IntervalCount": "", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918840528", "nextCommerceId": "61", "IntervalCount": "12", "FrequencyTitle": "week"}, 
                        {"shopifyId":  "44598918873296", "nextCommerceId": "67", "IntervalCount": "12", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918906064", "nextCommerceId": "53", "IntervalCount": "12", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918938832", "nextCommerceId": "71", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918971600", "nextCommerceId": "59", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918971600", "nextCommerceId": "59", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919004368", "nextCommerceId": "89", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919037136", "nextCommerceId": "95", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919069904", "nextCommerceId": "73", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919102672", "nextCommerceId": "65", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919135440", "nextCommerceId": "81", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919168208", "nextCommerceId": "79", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919200976", "nextCommerceId": "91", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919233744", "nextCommerceId": "93", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919266512", "nextCommerceId": "75", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919299280", "nextCommerceId": "99", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919332048", "nextCommerceId": "103", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598918217936", "nextCommerceId": "37", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919397584", "nextCommerceId": "87", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919561424", "nextCommerceId": "77", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919594192", "nextCommerceId": "101", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919626960", "nextCommerceId": "105", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919659728", "nextCommerceId": "97", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919692496", "nextCommerceId": "113", "IntervalCount": "12", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919725264", "nextCommerceId": "83", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919758032", "nextCommerceId": "107", "IntervalCount": "12", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919790800", "nextCommerceId": "111", "IntervalCount": "4", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919823568", "nextCommerceId": "27", "IntervalCount": "12", "FrequencyTitle": "week"},
                        {"shopifyId":  "44598919856336", "nextCommerceId": "109", "IntervalCount": "4", "FrequencyTitle": "week"},
                        
                    ];

  let selectedFrequency = $('input[name="selling_plan"]:checked').val();
  
  let checkOutChampId;
  let varId;
    //   if (selectedFrequency === '3_weeks') {
    //       checkOutChampId = $('#dropdown-product option:selected').attr('data-3-week-id');
    //       varId = $('#dropdown-product option:selected').attr('data-3-week-value');
    //   } else if (selectedFrequency === '4_weeks') {
    //      checkOutChampId = $('#dropdown-product option:selected').attr('data-4-week-id');
    //      varId = $('#linked-product-select option:selected').attr('data-4-week-value');
    //   }
  let variantId = $('#linked-product-select option:selected').val();
  
    let qty = 1;
    $.ajax({
      url: '/cart/clear.js',
      method: 'POST',
      dataType: 'json',
      success: function() {
          // After clearing, add the product
          $.ajax({
              url: '/cart/add.js',
              method: 'POST',
              data: { id: variantId, quantity: qty },
              dataType: 'json',
              success: function(data) {
                console.log('data added')
               $.getJSON('/cart.js', function(cart) {
                    
                    cart.items.forEach(function(item) {
                        // console.log("Cart Variant ID:", item.id, "Product ID:", item.product_id);

                        // Compare variant ID
                        var match = nextCommerceData.find(function(nc) {
                            return nc.shopifyId == item.id;
                        });
                         const lang = document.querySelector("html").getAttribute("lang") || "de";
                         const baseLang = lang.startsWith("fr") ? "fr" : "de";

                        if(match) {
                          console.log("Matched Variant ID:", item.id, "NextComment:", match.nextCommerceId);
                           let matchId = match.nextCommerceId;
                            // let IntervalCount = match.IntervalCount;
                            let IntervalCount = $('input[name="selling_plan"]:checked').attr('data-frequency');
                            let FrequencyTitle = match.FrequencyTitle;
                            let url = `https://pay.monpacha.ch/${baseLang}/checkout/add/?product=${matchId}:1`;

                            // only add IntervalCount if it exists
                            if (IntervalCount && IntervalCount !== "") {
                              url += `:${IntervalCount}`;
                              // only add FrequencyTitle if IntervalCount is there
                              if (FrequencyTitle && FrequencyTitle !== "") {
                                url += `:${FrequencyTitle}`;
                              }
                            }

                            // Offre tapis retirée le 30/07/2026 : le cadeau n'est autorisé que sur FR et UK.
                            // ?bonus=tapis n'ajoute plus rien, y compris depuis un ancien lien ou un favori.

                            window.location.href = url;

                          } else{
                            window.location = '/checkout';
                          }
                    });
                });

                  // window.location = `https://pay.mein-pacha.de/de/checkout?products=${checkOutChampId}:1`;
              },
              error: function(xhr, status, error) {
                  console.error("Error adding to cart:", error);
                  console.error("Response Text:", xhr.responseText);
                  window.alert(xhr.responseJSON.description);
              }
          });
      },
      error: function(xhr, status, error) {
          console.error("Error clearing cart:", error);
          console.error("Response Text:", xhr.responseText);
          window.alert("Failed to clear cart. Please try again.");
      }
  });
});

function goCheckout() {
    var val = $("#linked-product-select option:selected" ).text(); 
   
    if(val.indexOf("Katzen") != -1){
            checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');
    
        if (checkedRadio) {

            const quantityToSubmit = linkedProductsSelect ? 1 : quantity;

            const frequencyInputs = document.querySelectorAll('div[class="custom-recharge-form-radio"]');
            let frequency = "";

            frequencyInputs.forEach((input) => {
            radio = input.querySelector('input')
            label = input.querySelector('label')
            if (radio.checked)
                    frequency = label.textContent.replace('Livraison', 'livrés');
            });

            if(frequency.indexOf("3") != -1){
                var new_frequency = 3;
            } else {
                var new_frequency = 4;
            }
        
            let formData = {
                'items': [{
                    id: productId,
                    quantity: quantityToSubmit,
                    "properties": { "Lieferung": "alle "+new_frequency+" Wochen" }
                //  selling_plan: parseInt(checkedRadio.value)
                }]
            };

            console.log(formData);
            

            fetch(`/cart/add.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then((response) => response.json())
            .then(response => {
                window.location.href = '/checkout';
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }
    } else {
    
        checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');
    
        if (checkedRadio) {

            const quantityToSubmit = linkedProductsSelect ? 1 : quantity;
        
            let formData = {
                'items': [{
                    id: productId,
                    quantity: quantityToSubmit,
                    "properties": { "Livraison": checkedRadio.value }
                //  selling_plan: parseInt(checkedRadio.value)
                }]
            };

            console.log(formData);
            

            fetch(`/cart/add.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then((response) => response.json())
            .then(response => {
                window.location.href = '/checkout';
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }
    }
}

class ProductSelector extends HTMLElement{
    constructor(){
        super();

        this.select = this.querySelector('select');
    }

    connectedCallback(){
        this.setProductId();

        this.select.addEventListener('change', () => {
            this.setProductId();
            const activeOption = this.select.options[this.select.selectedIndex];
            this.setActiveFormRadios(activeOption.dataset.index);
        })

    }

    setProductId(){
        productId = parseInt(this.select.value);
    }

    setActiveFormRadios(index){
        const allRadios = document.querySelectorAll('.custom-recharge-form-radios')

        allRadios.forEach(radio => {
            if(radio.dataset.index === index){
                radio.classList.remove('hidden');

                const radioInputs =  radio.querySelectorAll('input');

                radioInputs[1].checked = true;
            }
            else{
                radio.classList.add('hidden');
            }
        })
    }
}

customElements.define('product-selector', ProductSelector);
